interface ButtonProps {
  /** Button variants */
  variant?: "primary" | "secondary" | "tertiary" | "danger";
  /** Button text content */
  text: string;
  /** Disabled state */
  disabled?: boolean;
  /** Optional icon path */
  imgPath?: string;
  /** Click handler */
  onClick: () => void;
  /** Additional className for custom styling */
  className?: string;
  /** Optional icon position */
  iconPosition?: "left" | "right";
  /** Full width button */
  fullWidth?: boolean;
  /** Button size */
  size?: "sm" | "md" | "lg";
  /** Show border */
  border?: boolean;
  icon?: JSX.Element;
}

export default function Btn({
  className = "",
  disabled = false,
  fullWidth = true,
  iconPosition = "left",
  imgPath,
  icon,
  size = "md",
  text,
  variant = "primary",
  onClick,
}: ButtonProps) {
  const baseStyles =
    "rounded-sm flex items-center justify-center font-medium cursor-pointer";

  const sizeStyles = {
    sm: "py-2 text-xs",
    md: "py-3 text-[13px]",
    lg: "py-4 text-sm",
  };

  const widthStyles = fullWidth ? "w-full" : "w-auto px-4";

  const variantStyles = {
    primary: `bg-primary text-white ${
      disabled ? "opacity-50 cursor-not-allowed" : "hover:bg-primary/90"
    }`,
    secondary: "bg-[#F4F7FE] text-[#2B3674] hover:bg-[#E9EEF9]",
    tertiary: "bg-transparent text-[#9A9EAD] hover:bg-gray-50",
    danger: "bg-red-600 text-white hover:bg-red-700",
  };

  const borderStyles = {
    primary: "border border-primary",
    secondary: "border border-[#F4F7FE]",
    tertiary: "border border-[#9A9EAD]",
    danger: "border border-red-600",
  };

  const disabledStyles = disabled ? "opacity-50 cursor-not-allowed" : "";

  const renderImage = () => {
    if (!imgPath) return null;

    return <img src={imgPath} className="h-[19px] w-auto" alt="" />;
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        ${disabledStyles}
        ${baseStyles}
        ${sizeStyles[size]}
        ${widthStyles}
        ${variantStyles[variant]}
        ${borderStyles[variant]}
        ${className}
      `}
    >
      {iconPosition === "left" && (icon || imgPath) && (
        <>
          {icon && <span className="mr-2">{icon}</span>}
          {imgPath && <span className="mr-1.5">{renderImage()}</span>}
        </>
      )}
      <span>{text}</span>
      {iconPosition === "right" && (icon || imgPath) && (
        <>
          {icon && <span className="ml-2">{icon}</span>}
          {imgPath && <span className="ml-1.5">{renderImage()}</span>}
        </>
      )}
    </button>
  );
}
